module.exports = __webpack_public_path__ + "assets/a-20-shuye.76b34ab0.svg";